import React, { FC } from "react";
import { ProductCatalogue } from "../ProductCatalogue/ProductCatalogue";
import { ProductsBlock } from "../../types/optimizely/blocks";
import { Product } from "../../types/product/product.types";

interface ProductSectionProps {
  module: ProductsBlock;
}

const mapEpiProductToModel = (module: ProductsBlock): Product[] => {
  return module.products.expandedValue.map((product) => {
    return {
      url: product.url,
      name: product.name,
      catalogueNumber: product.number.value,
      image: {
        ...product.images.value[0],
      },
    };
  });
};

const ProductSection: FC<ProductSectionProps> = ({ module }) => (
  <ProductCatalogue
    products={mapEpiProductToModel(module)}
    sectionTitle={module.title?.value || "Missing section title"}
    sectionId={module.sectionId?.value}
  />
);

export default ProductSection;
